






















import Vue from 'vue';
import ComponentPage from '@/components/page-constructor/ComponentPage.vue';
import ComponentUsageExample from '@/components/page-constructor/ComponentUsageExample.vue';
import AProgressCircular from '@/components/AProgressCircular.vue';

interface Data {
  basicUsageProgressValue: number;
  basicUsageProgressInterval: number | null;
}

export default Vue.extend({
  name: 'ProgressCircular',
  components: {
    ComponentPage,
    ComponentUsageExample,
    AProgressCircular,
  },
  data(): Data {
    return {
      basicUsageProgressValue: 0,
      basicUsageProgressInterval: null,
    };
  },
  created() {
    this.basicUsageProgressInterval = setInterval(() => {
      if (this.basicUsageProgressValue === 100) {
        this.basicUsageProgressValue = 0;
        return;
      }

      this.basicUsageProgressValue += 10;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.basicUsageProgressInterval!);
  },
});
